import Vue from 'vue'
import Router from 'vue-router'
// import {getToken, setToken} from '@/utils/VueCookies'
import Login from '@/views/login/login'
import homepage from '@/views/homepage/list'
import component from '@/views/component/list'
import decisionTable from '@/views/component/decision-table'
import scoreCard from '@/views/component/score-card'
import flowChat from '@/views/decisionTree/flow-chat'
import strategyEdit from '@/views/homepage/strategy-edit'
import versionManage from '@/views/versionManage/list'
import strategyDataRecord from '@/views/dataOperation/strategy-data-record'
import variablesCenter from '@/views/variablesCenter/list'
import UserContent from '@/components/include/UserContent'
// import AbnoermalOrder from '@/views/abnormalOrder/abnormal-order'
// import AllOrder from '@/views/allOrder/all-order'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/user',
      name: 'user',
      component: UserContent,
      redirect: "/homepage",
      children: [{
        path: "/homepage",
        name: 'homepage',
        component: homepage,
        meta: {
          title: "决策引擎"
        }
      }, /* {
        path: "/abnoermal-order",
        name: 'abnoermalOrder',
        component: AbnoermalOrder
      }, {
        path: "/all-order",
        name: 'allOrder',
        component: AllOrder
      }, */ {
        path: '/score-card',
        name: 'scoreCard',
        component: scoreCard
      },
      {
        path: '/decision-table',
        name: 'decisionTable',
        component: decisionTable
      },
      {
        path: '/flow-chat',
        name: 'flowChat',
        component: flowChat
      },
      {
        path: '/strategy-edit/:strategyCode/:strategyVersion',
        name: 'strategyEdit',
        component: strategyEdit
      },
      {
        path: '/strategy/version-manage',
        name: 'versionManage',
        component: versionManage
      },
      {
        path: '/strategy/strategy-data-record',
        name: 'strategyDataRecord',
        component: strategyDataRecord
      },
      {
        path: '/variables-center',
        name: 'variablesCenter',
        component: variablesCenter
      }]
    },
    {
      path: '/',
      name: 'index',
      component: UserContent
    },
    {
      path: '/component',
      name: 'component',
      component: component
    }
  ],
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  // let ssoUser = localStorage.getItem("ssoUser")
  // if (to.path === '/login') {
  //   if (ssoUser) {
  //     next({ path: '/' })
  //     return
  //   }
  //   next()
  //   return
  // }
  // if (!ssoUser) {
  //   next({ path: '/login' })
  //   return
  // }
  next()
  // next({ path: '/homepage' })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js